import * as firebase from "firebase";


export interface VideoConference {
    roomName: string;
    roomRef: string;
    expertPath: string; // full path => account/id/profile/id
    expertId: string; // profileId
    expertAccountId: string; // accountId
    status: ConferenceStatus;
    subscriberId: string;
    connectionStatus: ConnectionStatus;
    expertFullName: string;
    subscriberFullName: string;
    createdAt: Date;
    chatStartDate: Date;
    chatEndDate: Date;
    duration: string;
    totalAmount: number;
    payStatus: boolean;
    payConfirmCode: any;
    type: ConferencType;
    token: any;
    subscriberHere: boolean;
    apptStartDate: string;
    isAppt: boolean;
    apptPhone: any;
    apptDescription:string;
}

export enum ConnectionStatus {
    "not_started" = "not_started",
    "started" = "started",
    "ended" = "ended"
}

export enum ConferencType {
    "video" = "video",
    "audio" = "audio"
}

export enum ConferenceStatus {
    "pending" = "pending_expert_confirmation",
    "rejected" = "rejected_by_expert",
    "confirmed" = "confirmed_by_expert",
    "cancelled" = "cancelled_by_patient",
    "not_come" = "didnt_connect_to_conversation"
}